export default {
  spendField: 'thirty_day_spend',
  interpolateMonths: true,
  trendMetrics: [
    {
      metric: 1,
      field: 'adpi',
      label: 'Ad Effect Score',
      format: '.0f',
      scale: [80, 180]
    },
    {
      metric: 62,
      field: 'recall',
      label: 'Ad Recall',
      format: '.0%',
      hasSpendData: false,
      scale: [0, 1]
    },
    {
      metric: 3,
      field: 'consideration',
      label: 'Lift to Consideration',
      format: '.0%',
      scale: [0, 1]

    },
    {
      metric: 2,
      field: 'impression',
      label: 'Lift to Impression',
      format: '.0%',
      scale: [0, 1]
    },
    {
      metric: 5,
      field: 'actions',
      label: 'Net Actions',
      format: '.0%', 
      scale: [0, 1]
    },
  ]
}



// WEBPACK FOOTER //
// ./src/app/configuration/Optimum/config/components/scorecard/Trendchart/index.js